import moment from "moment";

const hostname = window.CURRENT_HOST;

console.log("hostname ====> ", hostname);

export function getApiUrl() {
  return window.API_URL;
}

export function getFrontBaseUrl() {
  if (hostname.includes("localhost")) {
    return "http://localhost:3000/home/";
  } else if (hostname.includes("-dev")) {
    return "https://my-dev.usapath.com/home/";
  } else {
    return "https://my.usapath.com/home/";
  }
}

//Convert into camelcase
export function toCamelCase(str: any) {
  if (!str) {
    return "";
  }
  return str.toLowerCase().replace(/\b\w/g, (s: any) => s.toUpperCase());
}

//Convert into camelcase
export function toUpperCase(str: any) {
  if (!str) {
    return "";
  }
  return str.toUpperCase();
}

export function anonymousUser() {
  let token = localStorage.getItem("token");

  if (token) {
    return false;
  } else {
    return true;
  }
}

// Generate a random GUID
export function generateGuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// To log the responses
export function logFunction(loggedData: any) {
  console.log("Logging data for you: ", loggedData);
}

// To log the responses error
export function logErrorFunction(loggedData: any) {
  console.error("Logging error data for you: ", loggedData);
}

// date-time format
export const formatDateTime = (date: string, format = "YYYY-MM-DD hh:mm A") => {
  return moment.utc(date).local().format(format);
};

export function removeSpaces(text: string) {
  return text?.replace(/\s+/g, "");
}

export const formatDateOnly = (date: string, format = "YYYY-MM-DD") => {
  // return moment(date).format(format);
  // Parse the server time string into a Date object
  const utcDate = new Date(date);
  // Get the offset between UTC and local time in minutes
  const offsetMinutes = utcDate.getTimezoneOffset();
  // Adjust the time to local by subtracting the offset
  const localDate = new Date(utcDate.getTime() - offsetMinutes * 60 * 1000);
  return moment(localDate).format(format);
};
